<ion-card>
    <ion-fab vertical="center" horizontal="end">
        <ion-fab-button *ngIf="document.customer.name && document.documentType !== 8" (click)="openModal(1)" size="small" color="light">
            <ion-icon name="search"></ion-icon>
        </ion-fab-button>
    </ion-fab>
    <ion-card-content *ngIf="!document.customer.name" (click)="openModal(1)">
        <ion-label>Select customer...</ion-label>
    </ion-card-content>
    <ion-card-content *ngIf="document.customer.name">
<!--        <ion-button expand="full" (click)="openModal(2)">Load Existing Contract</ion-button>-->
        <ion-label>
            <h4><strong>{{ document.customer.name }}</strong></h4>
            <p>{{ document.customer.cod }}</p>
            <p>{{ document.customer.add1 }}</p>
            <p>{{ document.customer.add2 }}</p>
            <p>{{ document.customer.add3 }}</p>
            <p>{{ document.customer.add4 }}</p>
        </ion-label>
    </ion-card-content>
</ion-card>
